import React, { useState, useEffect } from 'react';

const JobBannerCreator = (props) => {
  const [loading, setLoading] = useState(false);
  const { openJobs, handleRoute } = props;

  const formatDate = (date) =>
  new Date(date)
    .toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    })
    .replace(/ /g, "-");

  return (
    <div className="container-fluid py-2 bg-dark min-vh-50 d-flex align-items-center">
      <style>
        {`
          .marquee-container {
            overflow: hidden;
            white-space: nowrap;
            position: relative;
            padding: 10px 0;
          }

          .marquee-content {
            display: inline-flex;
            animation: scroll 30s linear infinite;
          }

          .marquee-content:hover {
            animation-play-state: paused;
          }

          @keyframes scroll {
            0% { transform: translateX(0); }
            100% { transform: translateX(-50%); }
          }

          .job-card {
            width: 380px;
            margin-right: 25px;
            border: none;
            border-radius: 15px;
            background: #ffffff;
            transition: transform 0.3s ease;
            white-space: normal; /* Allows text to wrap inside the card */
          }

          .job-card:hover {
            transform: translateY(-10px);
          }

          .card-accent {
            height: 6px;
            background: linear-gradient(90deg, #0d6efd, #6610f2);
            border-radius: 15px 15px 0 0;
          }
        `}
      </style>

      <div className="w-100">
       {/*} <div className="text-center mb-5 text-white">
          <h2 className="fw-bold text-uppercase tracking-widest">Active Openings</h2>
         {/*} <div className="badge bg-primary">Live Database Updates</div>
        </div>*/}

        {loading ? (
          <div className="text-center text-white">
            <div className="spinner-border" role="status"></div>
          </div>
        ) : (
          <div className="marquee-container">
            {/* We double the array to create a seamless infinite loop */}
            <div className="marquee-content">
              {[...openJobs, ...openJobs].map((job, index) => (
                <div key={`${job.jobPostingID}-${index}`} className="job-card shadow-lg">
                  <div className="card-accent"></div>
                  <div className="card-body p-4">
                    <div className="d-flex justify-content-between mb-3">
                      <span className="badge rounded-pill bg-light text-primary border border-primary px-3"> Job ID : {job.jobPostingID}</span>
                      <small className="text-danger fw-bold">Ends: {formatDate(job.removalDate)}</small>
                    </div>
                    
                    <h5 className="text-muted small mb-1">{job.schoolName}</h5>
                    <h3 className="h5 fw-bold mb-3">{job.positionApplied} - <span className="text-primary">{job.subject}</span></h3>
                    
                    <div className="row g-0 py-3 border-top border-bottom mb-3">
                      <div className="col-6">
                        <small className="d-block text-muted">Vacancies</small>
                        <span className="fw-bold">{job.noOfPositions} Position(s)</span>
                      </div>
                      <div className="col-6">
                        <small className="d-block text-muted">Location</small>
                        <span className="fw-bold text-truncate d-block small">{job.workLocation}</span>
                      </div>
                    </div>

                    <button className="btn btn-outline-primary w-100 rounded-pill fw-bold" onClick={event=>handleRoute(event,job)}>Apply Now</button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default JobBannerCreator;